<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Users Members",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Users Members",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Users Members",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Full Name",
          sortable: true,
        },
        {
          key: "role.name",
          label: "Role",
          sortable: true,
        },
        {
          key: "phone",
          label: "Phone Number",
          sortable: true,
        },
        {
          key: "username",
          label: "Username",
          sortable: true,
        },
        {
          key: "email",
          label: "Email Address",
          sortable: true,
        },
        {
          key: "user_status",
          label: "Status",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        staff: "",
        role: "",
        username: "",
        password: "",
      },
      deletedata: {
        name: "",
        status: "",
        id: "",
      },
      edit: {
        name: "",
        role: "",
        phone: "",
        id: "",
      },
      passwordEdit: {
        name: "",
        password: "",
        id: "",
      },
      roleError: "",
      usernameError: "",
      staffError: "",
      passwordError: "",
      existingUser: [],
      existStaff: [],
      modal: "",
    };
  },
  computed: {
    ...mapGetters("users", ["AllUsers", "AllRoles", "SaveStatus"]),
    ...mapGetters("staff", ["AllStaff"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllUsers ? this.AllUsers.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllUsers ? this.AllUsers.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStaffs: "staff/fetchStaff",
      FetchUsers: "users/fetchUsers",
      FetchRoles: "users/fetchRoles",
      AddUser: "users/addUser",
      EditUser: "users/editUser",
      EditPassword: "users/editPassword",
      DeleteUser: "users/deleteUser",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllUsers ? this.AllUsers.length : 1;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.username != "") {
        this.existingUser = this.AllUsers.filter((user) => {
          return (
            user.username.toUpperCase() == this.data.username.toUpperCase()
          );
        });
        if (this.existingUser.length) {
          this.usernameError = this.data.username + " exists already";
        } else {
          this.usernameError = "";
        }
      } else {
        this.existingUser = [];
      }
    },
    checkStaff() {
      //when creating a new one
      if (this.data.staff != "") {
        this.existStaff = this.AllUsers.filter((user) => {
          return user.staff_id == this.data.staff;
        });
        if (this.existStaff.length) {
          this.staffError = "This staff member already has an account";
        } else {
          this.staffError = "";
        }
      } else {
        this.existStaff = [];
      }
    },

    resetError() {
      this.roleError = "";
      this.usernameError = "";
      this.staffError = "";
      this.passwordError = "";
    },

    resetAddModal() {
      this.data.staff = "";
      this.data.username = "";
      this.data.password = "";
      this.data.role = "";
      this.resetError();
    },

    addUser(modal) {
      if (this.data.staff == "") {
        this.staffError = "Select Staff Member";
        return;
      } else {
        this.staffError = "";
      }
      if (this.data.role == "") {
        this.roleError = "Select Role";
        return;
      } else {
        this.roleError = "";
      }
      if (this.data.username == "") {
        this.usernameError = "Username Field is required";
        return;
      } else {
        this.usernameError = "";
      }
      if (this.data.password == "") {
        this.passwordError = "Password Field is required";
        return;
      } else {
        this.passwordError = "";
      }
      if (this.existingUser.length > 0) {
        this.usernameError = "Please this username is already taken";
        return;
      } else {
        this.usernameError = "";
      }
      if (this.existStaff.length > 0) {
        this.staffError =
          "Please this this staff member already has an account";
        return;
      } else {
        this.staffError = "";
      }
      this.modal = modal;
      this.AddUser(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.edit.id = values.item.id;
      this.edit.name = values.item.username;
      this.edit.role = values.item.role;
      this.edit.phone = values.item.phone;
    },
    changePassword(values) {
      this.passwordEdit.id = values.item.id;
      this.passwordEdit.name = values.item.username;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.username;
      this.deletedata.status = values.item.status;
    },
    deleteUser(modal) {
      this.modal = modal;
      this.DeleteUser(this.deletedata);
      this.closeModal(modal);
    },
    editUser(modal) {
      if (this.edit.staff == "") {
        this.staffError = "Staff Member field can't be empty";
        return;
      } else {
        this.staffError = "";
      }
      this.modal = modal;
      this.EditUser(this.edit);
      this.resetError();
      this.closeModal(this.modal);
    },
    editPassword(modal) {
      this.modal = modal;
      this.EditPassword(this.passwordEdit);
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchStaffs();
    this.FetchUsers();
    this.FetchRoles();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_users')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of System Users</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-user-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_users')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllUsers ? AllUsers : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <div
                    class="btn-group btn-group-sm"
                    role="group"
                    aria-label="Basic example">
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-user-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_users')
                        )
                      ">
                      <i class="fa fa-edit"></i> Edit
                      </b-button>
                    <b-button
                      v-if="data.item.user_status"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-user-modal
                      @click="showDeleteModal(data)"
                      ><i class="fa fa-times-circle" aria-hidden="true"></i>
                      Deactivate</b-button
                    >
                    <b-button
                      v-else
                      size="sm"
                      variant="success"
                      v-b-modal.delete-user-modal
                      @click="showDeleteModal(data)"
                      ><i class="fa fa-check" aria-hidden="true"></i> Activate
                    </b-button>
                    <b-button  size="sm" variant="warning"
                      v-b-modal.changePassword-modal
                      @click="changePassword(data)"
                      v-if="getCurrentUser.permissions.find((item) =>item.permission.includes('edit_users'))">
                      <i class="bx bx-error font-size-16 align-middle"></i>
                      Reset Password
                    </b-button>
                  </div>
                </template>
                <template #cell(user_status)="data">
                  <strong class="text-success" v-if="data.item.user_status">
                    Active
                  </strong>
                  <strong class="text-danger" v-else> Inactive </strong>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-user-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_users')
          )
        "
      >
        <template #modal-title> Add New User </template>
        <div class="row">
          <div class="form-group">
            <label>Staff</label>
            <div class="input-group">
              <model-list-select
                :list="AllStaff ? AllStaff : []"
                v-model="data.staff"
                option-value="id"
                option-text="name"
                class="mb-3"
                placeholder="Select Staff Member"
                @input="resetError(), checkStaff()"
              >
              </model-list-select>
            </div>
            <div class="text-danger" v-if="staffError">
              <em>{{ staffError }}</em>
            </div>
          </div>
          <div class="form-group">
            <label>Role</label>
            <div class="input-group">
              <model-list-select
                :list="AllRoles ? AllRoles : []"
                v-model="data.role"
                option-value="id"
                option-text="name"
                class="mb-3"
                placeholder="Select Role"
                @input="resetError()"
              >
              </model-list-select>
            </div>
            <div class="text-danger" v-if="roleError">
              <em>{{ roleError }}</em>
            </div>
          </div>
          <div class="form-group">
            <label>Username</label>
            <div class="input-group">
              <input
                type="text"
                placeholder="Enter Username"
                class="form-control"
                v-model="data.username"
                @input="checkName(), resetError()"
              />
            </div>
            <div class="text-danger" v-if="usernameError">
              <em>{{ usernameError }}</em>
            </div>
          </div>
          <div class="form-group">
            <label>Password</label>
            <div class="input-group">
              <input
                type="password"
                placeholder="Enter Password"
                class="form-control"
                v-model="data.password"
                @input="resetError()"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-user-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            v-if="SaveStatus"
            class="btn btn-sm btn-outline-primary"
            disabled
          >
            <b-spinner variant="light" small label="Spinning"></b-spinner>
            Submiting...
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addUser('add-user-modal')"
          >
            <i class="fa fa-check"></i>
            Submit User
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-user-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_users')
          )
        "
      >
        <template #modal-title> Edit User {{ edit.name }}</template>
        <div class="form-group mb-3">
          <label>Role</label>
          <div class="input-group">
            <model-list-select
              :list="AllRoles ? AllRoles : []"
              v-model="edit.role"
              option-value="id"
              option-text="name"
              placeholder="Select Role"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="roleError">
            <em>{{ roleError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Users Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="edit.name"
            />
          </div>
          <div class="text-danger" v-if="usernameError">
            <em>{{ usernameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Phone Number</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              @input="resetError"
              v-model="edit.phone"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-user-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm btn-outline-primary"
            disabled
          >
            <b-spinner variant="primary" small label="Saving"></b-spinner>
            Saving...
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="editUser('edit-user-modal')"
          >
            <i class="fa fa-save"></i>
            Save Changes
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- change password modal starts-->
      <b-modal
        id="changePassword-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_users')
          )
        "
      >
        <template #modal-title> Edit {{ passwordEdit.name }} Password</template>
        <form @submit.prevent="editPassword('changePassword-modal')">
        
        <div class="form-group mb-3">
          <label>Users Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="passwordEdit.name"
              disabled
            />
          </div>
        </div>
        <div class="form-group mb-3">
            <label>Password</label>
            <div class="input-group">
              <input
                type="password"
                placeholder="Change Password"
                required
                class="form-control"
                v-model="passwordEdit.password"
              />
            </div>
          </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('changePassword-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm btn-outline-primary"
            disabled
          >
            <b-spinner variant="primary" small label="Saving"></b-spinner>
            Saving...
          </button>
          <button
            v-else
            type="submit"
            class="btn btn-sm btn-outline-primary"
          >
            <i class="fa fa-save"></i>
            Save Password
          </button>
        </div>
        </form>
      </b-modal>
      <!-- Change modal ends -->


      <!-- modal delete Users starts -->
      <b-modal
        id="delete-user-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('deactivate_users')
          )
        "
      >
        <template #modal-title>
          <h5 class="text-danger">Confirm Action</h5></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to complete action?
              <br />
              Click Proceed Button to Confirm.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-user-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm btn-outline-danger"
            disabled
          >
            <b-spinner variant="danger" small label="Deleting"></b-spinner>
            Deleting...
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteUser('delete-user-modal')"
          >
            <i class="fa fa-check" aria-hidden="true"></i> Proceed
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
  </Layout>
</template>
